import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'common/image';
import { List, ListItem, Heading, Box, Text } from '@spothero/ui';
import useIsMobile from 'hooks/use-is-mobile';
const imgWidth = 200;
const imgHeight = 141;
const imgURL = `https://res.cloudinary.com/spothero/image/upload/c_fill,dpr_2.0,h_${imgHeight},w_${imgWidth},q_50,f_auto/`;
const HowToRedeem = ({ sectionTitle, instructions, displayImages = true, }) => {
    const isMobile = useIsMobile();
    return (<Box className="SpotDetails-section HowToRedeem" data-testid="HowToRedeem">
            <Heading as="h4" className="subtitle">
                {sectionTitle}
            </Heading>
            <List type="ordered" marginLeft={isMobile ? 5 : 0}>
                {instructions.map((instruction, i) => {
            const classes = classNames({
                'no-illustration': !instruction.illustration_id || !displayImages,
            }, { 'no-number': instructions.length < 2 });
            const key = `${instruction?.illustration_id}-${i}`;
            const imageUrl = instruction?.illustration?.url ||
                `${imgURL}${instruction.illustration_id}`;
            return (<ListItem className={classes} key={key}>
                            <Box className="RedemptionInstruction">
                                <Box className="RedemptionInstructionRow">
                                    <Box className="RedemptionInstructionIllustration">
                                        {instruction.illustration_id &&
                    displayImages && (<Image width={imgWidth} height={imgHeight} src={imageUrl}/>)}
                                    </Box>
                                    <Box className="RedemptionInstructionText">
                                        <Text as="span" className="RedemptionInstructionText-content" data-testid="RedemptionInstructionText-content" dangerouslySetInnerHTML={{
                    __html: instruction.text.replace('\n', '<br>'),
                }}/>
                                    </Box>
                                </Box>
                            </Box>
                        </ListItem>);
        })}
            </List>
        </Box>);
};
HowToRedeem.propTypes = {
    sectionTitle: PropTypes.string.isRequired,
    displayImages: PropTypes.bool,
    instructions: PropTypes.arrayOf(PropTypes.shape({
        illustration_id: PropTypes.string,
        illustration_version: PropTypes.string,
        text: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        position: PropTypes.number,
    })),
};
export default HowToRedeem;
